module.exports = __webpack_public_path__ + "static/media/imprint-de.01de61a5.md";